import React from "react";
import { pushGtmEvent } from "@/lib/gtm";

// Floating WhatsApp button — uses real number
const DEFAULT_MESSAGE = "Olá! Vim pelo site AEVOS e gostaria de mais informações.";

const WhatsAppFloat = ({ message = DEFAULT_MESSAGE, location = "float_button" }) => {
  const number = "5511941546532";
  return (
    <a
      href={`https://wa.me/${number}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noreferrer"
      className="wa-float"
      aria-label="Falar no WhatsApp"
      data-testid="whatsapp-float"
      onClick={() => pushGtmEvent("whatsapp_click", { location })}
    >
      <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12 0 12 12 0 0 0 1.6 17.93L0 24l6.21-1.63A11.93 11.93 0 0 0 12 24a12 12 0 0 0 8.52-20.52ZM12 21.84a9.85 9.85 0 0 1-5-1.36l-.36-.22-3.69.97.98-3.6-.24-.37A9.86 9.86 0 1 1 12 21.84Zm5.43-7.42c-.3-.15-1.77-.87-2-.97s-.46-.15-.66.15-.76.97-.93 1.17-.34.22-.64.07a8.05 8.05 0 0 1-2.36-1.46 8.92 8.92 0 0 1-1.64-2.04c-.17-.3 0-.46.13-.6s.3-.34.45-.51a2 2 0 0 0 .3-.5.55.55 0 0 0 0-.52c-.07-.15-.66-1.6-.9-2.18s-.48-.5-.66-.5h-.57a1.1 1.1 0 0 0-.8.37 3.34 3.34 0 0 0-1.04 2.49 5.8 5.8 0 0 0 1.22 3.07 13.27 13.27 0 0 0 5.07 4.49c.71.3 1.26.49 1.7.63a4.1 4.1 0 0 0 1.86.12 3.05 3.05 0 0 0 2-1.42 2.5 2.5 0 0 0 .17-1.42c-.07-.13-.27-.2-.57-.35Z"/>
      </svg>
    </a>
  );
};

export default WhatsAppFloat;
